
import { setAllConf } from "@/d";
setAllConf({
    context:'/igfish',
    useLocalResource:true
});

import Main from "./Main.vue";
import Vue from "vue";

import {stat} from "@/stat.js";

 new Vue({
    el: "#app",
    created:stat,
    render: h => h(Main)
});

// 不可移动
document.body.addEventListener('touchmove', function (e) {
    e.preventDefault();
}, {passive: false});



window.addEventListener("resize",function(){
    document.body.style.height = document.documentElement.clientHeight+"px";
}, false);


import "@/wxshare.js";





// root.mounted = ()=>{
    
// }









